import { TableApiConfig, TableState } from '../types';
import { TableAsyncActions, TableSyncActions } from './types';

const createAsyncActions = <T>(
  apiConfig: TableApiConfig<T>,
  syncActions: TableSyncActions,
  getState: () => TableState<T>
): TableAsyncActions => {
  return {
    fetchDataAsync: async () => {
      try {
        syncActions.setLoading(true);
        syncActions.setError(null);

        const state = getState();

        let sorting: string | undefined = undefined;
        if (state.sortField && state.sortDirection) {
          sorting = `${state.sortField} ${state.sortDirection}`;
        }

        const params = {
          pageNumber: state.currentPage,
          pageSize: state.pageSize,
          searchString: state.searchString || undefined,
          sorting,
          // Tri serveur (sortBy/sortDirection) — sorting reste pour le legacy
          sortBy: state.sortField || undefined,
          sortDirection: state.sortDirection || undefined,
          filters: Object.keys(state.filters).length > 0 ? state.filters : undefined
        };

        const response = await apiConfig.fetchData(params);

        syncActions.setData(response);
        syncActions.updateLastFetchParams();
      } catch (error) {
        syncActions.setError(
          error instanceof Error ? error.message : 'Une erreur est survenue'
        );
        syncActions.updateLastFetchParams();
      }
    },

    fetchFiltersAsync: async () => {
      if (!apiConfig.fetchFilters) {
        console.warn('fetchFilters not configured for this table');
        return;
      }

      try {
        syncActions.setLoadingFilters(true);
        syncActions.setError(null);

        const filters = await apiConfig.fetchFilters();
        syncActions.setFiltersReferential(filters);
      } catch (error) {
        syncActions.setError(
          error instanceof Error ? error.message : 'Une erreur est survenue lors du chargement des filtres'
        );
        syncActions.setLoadingFilters(false);
      }
    }
  };
};

export default createAsyncActions;
